export const iconStyles = {
  height: '1.5rem',
  width: '1.5rem',
  marginX: 0
};

export const footerContainerStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  ml: 'auto',
  mr: 'auto'
};

export const topicTagStyles = {
  lineHeight: 'normal',
  height: 'fit-content',
  margin: '2px !important',
  padding: 0.5,
  fontSize: '0.8125rem',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  maxWidth: '10rem',
  '@media (max-width: 600px)': {
    fontSize: '0.75rem'
  }
};

export const flagStyles = {
  iconButton: {
    padding: 0
  },
  icon: {
    size: '15'
  },
  color: '#E71111'
};
